import React from 'react';
import { WebsiteDesignProps } from './types';
import { MousePointer2, Star } from 'lucide-react';
import { Button } from "@/components/ui/button";

const NeoBrutalist: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Raw School";

    return (
        <div className="bg-[#FFDEE9] min-h-screen font-mono text-black selection:bg-purple-400">
            <nav className="border-b-4 border-black p-6 flex justify-between items-center bg-white">
                <div className="text-2xl font-black uppercase tracking-tighter shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] bg-yellow-300 border-2 border-black px-2 transform -rotate-2">
                    {schoolName}
                </div>
                <div className="hidden md:flex gap-6 font-bold">
                    <a href="#" className="hover:bg-black hover:text-white px-2 py-1 transition-all">Start</a>
                    <a href="#" className="hover:bg-black hover:text-white px-2 py-1 transition-all">Learn</a>
                    <a href="#" className="hover:bg-black hover:text-white px-2 py-1 transition-all">Play</a>
                </div>
                <Button className="border-2 border-black bg-purple-400 text-black font-bold uppercase rounded-none shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] transition-all">
                    Sign Up Now
                </Button>
            </nav>

            <main className="p-6 md:p-12">
                <div className="border-4 border-black bg-white p-8 md:p-16 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] relative">
                    <div className="absolute -top-6 -right-6 bg-blue-400 border-4 border-black p-4 rotate-12 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] font-bold uppercase z-10">
                        Top Rated!
                    </div>
                    <h1 className="text-6xl md:text-8xl font-black leading-none mb-8 uppercase">
                        We Teach <br/> <span className="bg-green-400 px-2">Real</span> Skills.
                    </h1>
                    <p className="text-xl md:text-2xl font-bold mb-12 max-w-2xl border-l-8 border-black pl-6">
                        No fluff. Just hard knowledge. We are the antidote to boring education.
                    </p>
                    <div className="flex flex-col md:flex-row gap-6">
                        <Button className="h-16 px-8 text-xl border-4 border-black bg-red-400 text-black font-black uppercase rounded-none shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[4px] hover:translate-y-[4px] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                            Enroll Today
                        </Button>
                        <div className="flex items-center gap-2 font-bold">
                            <MousePointer2 className="rotate-[-45deg]" /> Click above, it works.
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
                    <div className="border-4 border-black bg-yellow-300 p-8 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
                        <h2 className="text-4xl font-black uppercase mb-4 flex items-center gap-4">
                            <Star className="fill-black" /> Events
                        </h2>
                        <ul className="list-disc pl-6 font-bold space-y-2 text-lg">
                            <li>Pizza Party - Friday</li>
                            <li>Coding Marathon - Sat</li>
                            <li>Design Sprint - Mon</li>
                        </ul>
                    </div>
                    <div className="border-4 border-black bg-blue-300 p-8 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] flex items-center justify-center">
                         <img src="https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=2070&auto=format&fit=crop" className="border-4 border-black grayscale contrast-125 w-full h-64 object-cover" alt="Students" />
                    </div>
                </div>
            </main>
        </div>
    );
};

export default NeoBrutalist;
